import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {DxLoadPanelModule, DxPopupModule} from 'devextreme-angular';
import {AsyncPipe, NgClass} from '@angular/common';
import {ScreenService} from "@services";
import {Nl2brPipe} from "../../../pipes/nl-2-br.pipe";

@Component({
    selector: 'app-popup-message',
    template: `
        <dx-popup
            [fullScreen]="!!(screen.xSmallScreenChanged | async)"
            [width]="600"
            [maxHeight]="500"
            height="auto"
            [showTitle]="true"
            [title]="title"
            [dragEnabled]="false"
            [showCloseButton]="true"
            [visible]="visible"
            (visibleChange)="visibleChange.emit($event)"
        >
            <div class="fs-6 text-wrap text-break" [ngClass]="{ 'text-danger': isError }" [innerHTML]="message | nl2br"></div>
            @if (isLoading) {
                <div class="position-relative mt-3" style="min-height: 60px;">
                    <dx-load-panel
                        [visible]="true"
                        [showPane]="false"
                        [shading]="false"
                        [position]="{ of: '.position-relative' }"
                        container=".position-relative"
                    ></dx-load-panel>
                </div>
            }
        </dx-popup>
    `,
    standalone: true,
    imports: [DxPopupModule, DxLoadPanelModule, NgClass, AsyncPipe, Nl2brPipe]
})
export class PopupMessageComponent {
    protected screen = inject(ScreenService);

    @Input() title: string = '';
    @Input() message: string = '';
    @Input() isError: boolean = false;
    @Input() visible: boolean = false;
    @Input() isLoading: boolean = false;
    @Output() visibleChange = new EventEmitter<boolean>();
}
